import Button from '@mui/material/Button'
import styled from '@mui/material/styles/styled'

export const ActionButton = styled(Button, { name: 'ActionButton' })`
  background-color: theme.palette.primary.contrastText;
  :hover {
    background-color: theme.palette.primary.contrastText;
  }
`
